import { isMoment } from "moment-timezone"
import getMomentDateObj from "./getMomentDateObj"
import setMomentDateObjZero from "./setMomentDateObjZero"

const getDayKey = (date, timezone = null) => {
    if(isMoment(date)) {
        return setMomentDateObjZero(date.clone()).toISOString()
    } else if(date && timezone){
        return setMomentDateObjZero(getMomentDateObj(date, timezone)).toISOString()
    } else {
        error.log('Could not create day key')
    }
}

export default getDayKey